import type { CardInput, IProvider } from '../types';

export class FakeProvider implements IProvider {
  constructor(private readonly gatewayConfigId: string) {}

  async generate(card: CardInput): Promise<string> {
    const lastDigits = card.number.replace(/\s/g, '').slice(-4);
    return `fake_tok_${lastDigits}_${Date.now()}`;
  }
}
